import React, { Component } from 'react'
import {Box,Paper,Grid2, Container, Typography,Checkbox, Divider, Button} from '@mui/material'
import Appbar from './Appbar'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import AddIcon from '@mui/icons-material/Add';

import RemoveIcon from '@mui/icons-material/Remove';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import base_url from './base_url';



export class OrderList extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       orderList : []
    }
  }


  componentDidMount(){
    let email = localStorage.getItem('email');
    fetch(
      `${base_url.base_url}/orderList/retriveOrderList`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "post",
        body : JSON.stringify({
         email : email
        })
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
     this.setState({
      orderList : result.data
     })
      });

  }



instantRetrive=()=>{
  let email = localStorage.getItem('email');
  fetch(
    `${base_url.base_url}/orderList/retriveOrderList`,
    {
      headers: {
        "content-type": "application/json",
      },
      method: "post",
      body : JSON.stringify({
       email : email
      })
    }
  )
    .then((res) => {
      return res.json();
    })
    .then((result) => {
   this.setState({
    orderList : result.data
   })
    });
}




cancelProductNow=(order_id)=>{
  let email = localStorage.getItem('email');
  fetch(
    `${base_url.base_url}/orderList/updateStatus`,
    {
      headers: {
        "content-type": "application/json",
      },
      method: "put",
      body : JSON.stringify({
       order_id : order_id,
       email  : email
      })
    }
  )
    .then((res) => {
      return res.json();
    })
    .then((result) => {
  this.instantRetrive()
    });

}



  render() {
    return (
      <div>
<Box sx={{backgroundColor:'#e9edee'}}>
<Appbar/>
<br/>
<br/>
<br/>

<Container maxWidth='xl'>

<Grid2 container spacing={1}>

<Grid2 item size={{xs:12,sm:2}}>
<Box>
<Paper variant='outlined' sx={{minHeight:140,width:'100%'}}>


<Typography  sx={{fontSize:14,fontWeight:'600',textTransform:'uppercase',color:'#1d294f',ml:2,mt:1,mb:1}}>Select Category</Typography>

<Divider/>

<Box sx={{display:'flex',flexDirection:'row',justifyContent:'left',alignItems:'center',ml:1,mt:1}}>
<Checkbox size='small'/> <Typography sx={{fontSize:12,textTransform:'uppercase'}}>DELIVERD PRODUCTS</Typography>
</Box>

<Box sx={{display:'flex',flexDirection:'row',justifyContent:'left',alignItems:'center',ml:1,mt:0.2}}>
<Checkbox size='small'/> <Typography sx={{fontSize:12,textTransform:'uppercase'}}>CANCEL PRODUCTS</Typography>
</Box>
{
    //// right section list
}






</Paper>
</Box>
</Grid2>

<Grid2 item size={{xs:12,sm:10}}>
<Box>


<Paper variant='outlined' sx={{minHeight:60,width:'100%',display:'flex',justifyContent:'center',flexDirection:'column'}}>

<Typography sx={{fontSize:15,fontWeight:'600',color:'black',pl:2,textTransform:'uppercase'}}>ORDERED PRODUCTS</Typography>
<Typography sx={{fontSize:12,fontWeight:'500',color:'black',pl:2}}>You have previously ordered below products.</Typography>

</Paper>

<Box sx={{minHeight:400,width:'100%',mt:1,backgroundColor:'transparent'}}>
<Box sx={{p:0}}>


{
  this.state.orderList.map((i)=>(

<Paper variant='outlined' sx={{minHeight:230,mt:0.5,mb:0.5,backgroundColor:'#fff'}} >
<Grid2 container spacing={3}>
<Grid2 item size={{xs:12,sm:3}}>
<Box sx={{width:'100%',display:'flex'}}>
<img src={`${base_url.base}` + "/" + `${i.items[0].thumb_nail_img}`} style={{height:225,width:'100%'}}/>
</Box>
</Grid2>
<Grid2 item size={{xs:12,sm:9}}>
<Box>

<Box sx={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
<Typography sx={{fontSize:16,fontWeight:'600',color:'black',mt:{xs:0,sm:1},p:1}}>{i.items[0].product_name}   {this.state.orderList.length - 1}  'MORE'   </Typography>
<Button size='small' onClick={this.cancelProductNow.bind(this,i.order_id)} color="error" disableElevation variant='contained' sx={{m:1,fontSize:11,display:i.status=='Cancel'?'none':'block'}}>Cancel now</Button>
</Box>


<Typography sx={{fontSize:11,fontWeight:'600',color:'#09488b',textTransform:'uppercase',pl:1}}>in stock</Typography>
{
  /*
<Box sx={{display:'none',justifyContent:'left',mt:1,mb:1,pl:1}}>
<img src={tags} style={{height:20,width:83,objectFit:'fill'}}/>
</Box>

  */
}


<Box sx={{display:'flex',justifyContent:'left',mt:0.5,mb:0.5,pl:1}}>
<Typography sx={{fontSize:15,fontWeight:'600',color:'#2c2c2c'}}>Price :{i.items[0].price} /-</Typography>
</Box>

<Box sx={{display:'flex',justifyContent:'left',mt:0.5,mb:0.5,pl:1}}>
<Typography sx={{fontSize:12,fontWeight:'600',color:'#2c2c2c'}}>Quantity : {i.items[0].weight}gram</Typography>
</Box>




<Box sx={{width:100,height:30,border:2,borderColor:'green',borderRadius:8,display:'flex',justifyContent:'center',alignItems:'center',mt:2,mb:1,ml:1}}>
<Typography textAlign='center' sx={{fontSize:14,fontWeight:'600'}}>{i.status}</Typography>  

<Box sx={{height:20,width:20,backgroundColor:'green',borderRadius:8,ml:0.5,display:'flex',justifyContent:'center',alignItems:'center'}}>
<CheckIcon sx={{height:15,width:15,color:'#fff'}}/>
</Box>

</Box>

</Box>
</Grid2>
</Grid2>

</Paper>

  ))
}






</Box>
</Box>






</Box>
</Grid2>

</Grid2>



</Container>
</Box>
      </div>
    )
  }
}

export default OrderList





